import model from '../mixins/model';
import {isRecoveryCode, isVerificationCode} from "@/services/vault";

export default {
    mixins: [model],
    form: true,
    model() {
        return {
            code: ''
        }
    },
    methods: {
        canSubmit() {
            return this.$auth.flow.useRecoveryCode ? isRecoveryCode(this.model.code) : isVerificationCode(this.model.code);
        },
        toggleRecoveryCode() {
            this.$auth.flow.useRecoveryCode = !this.$auth.flow.useRecoveryCode;
            this.model.code = '';
            this.isError = false;
        },
        sendEmailCode() {
            this.$auth.sendEmailCode().catch(() => {});
        },
        submit(e) {
            e.preventDefault();

            if (!this.canSubmit() || this.loading)
                return;

            this.dispatch((resolve, reject) => {

                this.$auth.verifyTwoFactor(this.model.code).then(resolve).catch(reject);

            }).then((status) => {

                if (status === 'VERIFIED')
                    this.$router.push({name: "agent"});
            }).catch(() => {
                this.model.code = '';
            });
        }
    }
}
